import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import DtoSelectionRow from '../../../dashboard/dto/DtoSelectionRow'
import AppStore from '../../../store/AppStore'
import SelectionAction from '../../../dashboard/actions/SelectionAction'
import i18n from 'simple-react-i18n'
import DtoUserCredit from '../../../home/dto/DtoUserCredit'
import DtoUser from '../../../home/dto/DtoUser'
import { push } from 'react-router-redux'
import { PATH_ADMINISTRATION_CREDIT } from '../../../home/constants/HomeConstants'
import Chip from '@material-ui/core/Chip'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button'
import Slide from '@material-ui/core/Slide'
import { css } from 'glamor'
import ToastrAction from '../../../home/actions/ToastrAction'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import { find } from 'lodash'
import { SITE_DATA_EXPORT_OPTION, SITE_DESCRIPTION_EXPORT_OPTION } from '../../../dashboard/constants/SelectionConstants'


const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction='up' ref={ ref } { ...props } />
})


class SelectionExportModal extends Component {

	constructor(props) {
		super(props)
		this.state = {
			selectedOptions: [SITE_DESCRIPTION_EXPORT_OPTION, SITE_DATA_EXPORT_OPTION]
		}
	}

	handleClose = () => {
		AppStore.dispatch(SelectionAction.closeModalSelectionExport())
	}

	pushTo = () => {
		AppStore.dispatch(push(PATH_ADMINISTRATION_CREDIT))
	}

	export = () => {
		if (!this.props.user.email) {
			AppStore.dispatch(ToastrAction.error(i18n.warning.pleaseMailInform))
		} else {
			AppStore.dispatch(SelectionAction.exportSelection(this.props.user.login, this.props.selectedSelectionInformation.id, this.state.selectedOptions))
		}
	}


	getAvailable = () => {
		if (this.props.selectedSelectionInformation.selectionWatershed && this.props.selectedSelectionInformation.selectionWatershed.length) {
			const totalCredit = this.props.selectedSelectionInformation.themes.length * this.props.selectedSelectionInformation.selectionWatershed.length
			return (() => {
				if (this.props.userCredit && (this.props.userCredit.credit)) {
					return this.props.userCredit.credit > totalCredit
				}
				return false
			})()
		}
		return false
	}

	getCreditAfterExport = () => {
		const totalCredit = this.props.selectedSelectionInformation.themes.length * this.props.selectedSelectionInformation.selectionWatershed.length
		return this.props.userCredit.credit - totalCredit
	}

	getCreditMessage = (isAvailable) => {
		if (!isAvailable) {
			return (
				<Chip>
					{ i18n.insufficientCreditExport }
				</Chip>
			)
		}
		const finalCreditAfterExport = this.getCreditAfterExport()
		return (<span>{ i18n.information.finalCreditAfterExport } : { finalCreditAfterExport } </span>)
	}

	getDialogAction = () => {
		if (this.props.selectedSelectionInformation && this.props.modalSelectionExport) {
			const isAvailable = this.getAvailable()
			const isDisabled = (() => {
				return !this.state.selectedOptions.filter(o => o === SITE_DESCRIPTION_EXPORT_OPTION || o === SITE_DATA_EXPORT_OPTION).length > 0
			})()
			const backgroundColor = (() => {
				if (isDisabled) {
					return '#BDBDBD !important'
				}
				return '#53A1FF !important'
			})()
			const validateFunction = (() => {
				if (isAvailable) {
					return (
						<Button onClick={ this.export } { ...css({ backgroundColor: backgroundColor, color: 'white !important' }) } autoFocus disabled={ isDisabled }>
							{ i18n.validate }
						</Button>
					)
				}
				return (
					<Button onClick={ this.pushTo } { ...css({ backgroundColor: backgroundColor, color: 'white !important' }) } autoFocus disabled={ isDisabled }>
						{ i18n.recharge }
					</Button>
				)
			})()
			return (
				<DialogActions>
					<Button onClick={ this.handleClose } { ...css({ backgroundColor: 'red !important', color: 'white !important' }) }>
						{ i18n.cancel }
					</Button>
					{ validateFunction }
				</DialogActions>
			)
		}
		return null
	}
	getContent = () => {
		if (this.props.selectedSelectionInformation && this.props.modalSelectionExport) {
			const siteClassName = (() => {
				if (find(this.state.selectedOptions, o => o === SITE_DESCRIPTION_EXPORT_OPTION)) {
					return 'col s12 no-padding checkbox-selected'
				}
				return 'col s12 no-padding'
			})()
			const dataClassName = (() => {
				if (find(this.state.selectedOptions, o => o === SITE_DATA_EXPORT_OPTION)) {
					return 'col s12 no-padding checkbox-selected'
				}
				return 'col s12 no-padding'
			})()
			return (
				<div className='row export-modal'>
					{ i18n.question.exportSelection }
					<div className={ siteClassName }>
						{ this.getCheckBoxExportOptions('Description des sites', SITE_DESCRIPTION_EXPORT_OPTION) }
					</div>
					<div className={ dataClassName }>
						{ this.getCheckBoxExportOptions('Données des sites', SITE_DATA_EXPORT_OPTION) }
					</div>
				</div>
			)
		}
		return null
	}
	getTitle = () => {
		if (this.props.selectedSelectionInformation && this.props.modalSelectionExport) {
			return (
				<DialogTitle id='alert-dialog-slide-title' className='export-modal-title'>{ i18n.exportSelection } : <span>{ this.props.selectedSelectionInformation.title }</span></DialogTitle>
			)
		}
		return null
	}

	changeSelectedOption = (parameter) => {
		const tmpValue = (() => {
			const tmp = [...this.state.selectedOptions]
			if (find(tmp, o => o === parameter)) {
				return tmp.filter(o => o !== parameter)
			}
			return tmp.concat([parameter])
		})()
		this.setState({
			selectedOptions: tmpValue
		})
	}

	getCheckBoxExportOptions = (title, parameter) => {
		const isSelected = find(this.state.selectedOptions, o => o === parameter)
		return (
			<FormControlLabel
				control={
					<Checkbox
						checked={ isSelected }
						onChange={ () => this.changeSelectedOption(parameter) }
						value={ parameter }
						color='primary'
					/>
				}
				label={ title }
			/>
		)
	}

	render() {
		return (
			<Dialog
				maxWidth='sm'
				fullWidth={ true }
				TransitionComponent={ Transition }
				modal={ false }
				keepMounted
				open={ this.props.modalSelectionExport }
				onClose={ this.handleClose }
			>

				{ this.getTitle() }
				{ this.getContent() }
				{ this.getDialogAction() }
			</Dialog>
		)
	}

}

SelectionExportModal.propTypes = {
	selectedSelectionInformation: PropTypes.instanceOf(DtoSelectionRow),
	modalSelectionExport: PropTypes.bool,
	user: PropTypes.objectOf(DtoUser),
	userCredit: PropTypes.objectOf(DtoUserCredit)
}
const mapStateToProps = store => {
	return {
		selectedSelectionInformation: store.SelectionReducer.selectedSelectionInformation,
		modalSelectionExport: store.SelectionReducer.modalSelectionExport,
		user: store.HomeReducer.user,
		userCredit: store.CreditReducer.userCredit
	}
}

export default connect(mapStateToProps)(SelectionExportModal)



// WEBPACK FOOTER //
// ./src/components/modal/selection/SelectionExportModal.js